import { Box } from '@mui/material';
import { withTheme } from '@mui/styles';
import styled from 'styled-components';

export const FooterCpdDetail = withTheme(styled(Box)`
  background: linear-gradient(92.76deg, #538d87 24.56%, #164843 93.61%);
  color: white;
  position: ${(props: any) => (props.isSticky ? 'sticky' : 'relative')};
  bottom: 0;
  width: 100%;
  height: 160px;

  ${(props: any) => props.theme.breakpoints.down('md')} {
    height: 80px;
  }
`);
